export enum StorageKey {
  EmailSendTime = 'est',
  AuthToken = 'atn',
  AuthStatus = 'as',
  OuterRoute = 'or',
  RegistrationEmail = 're',
  OneTimePassword = 'op',
}
